<div class="container-error">
  <div class="contentBox">
    <div class="center-error">
      <div>
        <img
          class="valida-error marbo-20"
          src="assets/images/payvalida.svg"
          alt=""
        />
        <h2 class="">¡Tu transacción no se pudo procesar correctamente!</h2>
        <p class="marbo-20">
          Vuelve a intentarlo.
        </p>
        <div *ngIf="transaction && isValidToken()">
          <a class="returnMerchant" [href]="transaction?.MERCHANT_URL_RETURN"><fa-icon icon="arrow-left" size="lg"></fa-icon> Volver a {{transaction?.MERCHANT_NAME}}</a>
        </div>
      </div>
    </div>
    <div class="center-error">
      <img
        class="img-error"
        src="../../../assets/images/error.png"
        alt=""
      />
    </div>
  </div>
</div>
